'use strict';

/**
 * @function
 * @description open and close the autocomplete dropdown as per given parameter parentEle and inputEle
 * @param {String} parentEle the parent container of autocomplete dropdown and input field
 * @param {String} inputEle the id of the input field where autocomplete dropdown shown
 */
module.exports = function (parentEle, inputEle) {
    var parentEle = $('.' + parentEle);
    var inputEle = $('#' + inputEle);
    $(parentEle).find('.arrow-bottom').off('click').on('click', function() {
        var list = $(this).closest(parentEle).find('.ui-autocomplete');
        if (!list.hasClass('show')) {
            $(list).addClass('show'); // add the class in autocomplete list container
            $(inputEle).autocomplete('search', '').trigger('focus'); // open autocomplete list
        } else {
            $(list).removeClass('show'); // remove the class in autocomplete list container
            setTimeout(function () { // it reopen automatically, settimeout will run the code after reopen
                $(inputEle).autocomplete('close'); // close autocomplete list
            }, 100);
        }  
    });

    // Close the autocomplete container at click of outside of input
    $(document).off('click').on('click', function(e) {
        var container = $(parentEle);
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find('.ui-autocomplete').removeClass('show');
        }
    });
};
